/* eslint-disable jsx-a11y/label-has-associated-control  */
import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { FcIdea } from "react-icons/fc";
import { useFormContext,Controller } from 'react-hook-form';
import Select from 'react-select';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    wrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 1rem 0', 
        textAlign: 'left',
        color:"#333",
      },
      fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label':{
            fontFamily: 'VodafoneRg-bold', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            display:'block',
        },
        '& input[type="number"],input[type="date"],select':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            borderColor:'#333'
        },
        '& input[type=date]:before':{content:'none'},
        '& textarea':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize:'none'
        },
        
        
    },
   
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        margin: '2rem 0 0.5rem 0', 
        fontSize: '1.125rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    text:{
        fontFamily: 'VodafoneRg-regular', 
        margin: '0 0 0.5rem 0', 
        fontSize: '1rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    
    wrpcols:{
        display: 'grid',
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: '1rem',
        marginBottom:theme.spacing(2)
    },
  }));
  

export const EvaluationFlow = (props) => {
// console.log("🚀 ~ EvaluationFlow ~ props:", props)
const { listScorecardTemplate } = props || {}
const classes = useStyles();
const { setValue, trigger, getValues, formState: { errors } } = useFormContext();
const [selectedTemplate, setSelectedTemplate] = React.useState(null);


useEffect(() => {
    const savedTemplate = getValues('templateScorecard');
    if (savedTemplate) {
        setSelectedTemplate(savedTemplate);
    }
}, []);

const handleSelect = (template) => {
    setSelectedTemplate(template);
    setValue('templateScorecard', template, { shouldValidate: true }); // update + validate
    trigger('templateScorecard'); // manually trigger validation
};


  return (
    <div className={classes.wrp}>
        <h2 className={classes.title}>Evaluation Workflow Setup </h2>
        <span className={classes.text}>Configure how ideas will be evaluated through different  stages and by whom.</span>
        
        {/* <h3 className={classes.labelname}>Configuration Options</h3>

<fieldset className={classes.fieldsetBox}>
    <label htmlFor='evaluationGroupMember'  >Evaluation Group Members</label>
    <Controller
        name="evaluationGroupMember"
        control={control}
        render={({ field }) => (
            <Select
            {...field}
            options={challengeOwnerOption}
            isMulti
            placeholder="Select..."
            id="evaluationGroupMember"
            styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#333',
                }),
              }}
          />
        )}
    />
    {errors?.evaluationGroupMember?.message && <p className={classes.error}>{errors?.evaluationGroupMember?.message}</p>}
</fieldset> */}

        <h3 className={classes.labelname}>Choose Scorecard Template</h3>
        {errors?.templateScorecard && (
                <p className={classes.error}>{errors.templateScorecard.message}</p>
            )}
        <div className={classes.wrpcols}>
            {
                    listScorecardTemplate?.map((templatelist,index)=>{
                        // console.log("Scorecard $$ Index", templatelist.templateName,index)
                        return(
                                <IdeaTemplateSelectCard  
                                    key={templatelist.templateName}
                                    ideaName={templatelist.templateName}
                                    currentIndex={index}
                                    onClick={() => handleSelect(templatelist)}
                                    templatelistId={templatelist.id}
                                    selectedTemplateId={selectedTemplate?.id}
                                 />
                        )
                    })
            }
            
        </div>
        {selectedTemplate &&   <h3 className={classes.title}>Selected Template : {selectedTemplate?.templateName}</h3> }

       

        {/* <fieldset className={classes.fieldsetBox}>
            <label htmlFor='ideaCanNotReject'>Idea cannot be rejected at this stage</label>
            <Switch
                checked={ideaCanNotReject}
                onChange={handleChange}
                name="ideaCanNotReject"
                id="ideaCanNotReject"
                inputProps={{ 'aria-label': ' checkbox' }}
            />
        </fieldset>

        <h3 className={classes.labelName}>Progress Criteria</h3>
        {
            !ideaCanNotReject && 
            <fieldset className={classes.fieldsetBox}>
                <label htmlFor='progressThresholdValue'>Threshold Value</label>
                <input 
                    type='number' 
                    name="progressThresholdValue" 
                    id='progressThresholdValue'  
                    placeholder='Enter minimum score (e.g. 40)' 
                    {...register('progressThresholdValue')}
                    className={` ${errors?.progressThresholdValue ? classes.invalid: ''}`}
                    aria-invalid={errors?.progressThresholdValue ? "true" : "false"}
                    
                />
                {errors?.progressThresholdValue?.message && <p className={classes.error}>{errors?.progressThresholdValue?.message}</p>}
            </fieldset>
        }
        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='progressThresholdValue'>Evaluation must be achieved by at least (1) out of (2) approvers.</label>
            <input 
                type='number' 
                name="progressThresholdValue" 
                id='progressThresholdValue'  
                placeholder='Enter atleast 1 approvers (e.g. 1)' 
                {...register('progressThresholdValue')}
                className={` ${errors?.progressThresholdValue ? classes.invalid: ''}`}
                aria-invalid={errors?.progressThresholdValue ? "true" : "false"}
                
            />
            {errors?.progressThresholdValue?.message && <p className={classes.error}>{errors?.progressThresholdValue?.message}</p>}
        </fieldset>


        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='sendReminder'>Send Reminders</label>
            <Switch
                checked={sendReminderEnable}
                onChange={handleChangeSendReminder}
                name="sendReminder"
                id="sendReminder"
                inputProps={{ 'aria-label': ' checkbox' }}
            />
           {sendReminderEnable && <p className={classes.text}>Reminders will be sent every 1 days until task is actioned or workflow progresses past this stage.</p> }
        </fieldset> */}



    </div>
  )
}





const useStylesIdeaTemplateSelectCard = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    labelName:{
        fontFamily: 'VodafoneRg-bold', 
        margin: '0 0 0.5rem 0', 
        fontSize: '1.125rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    ideaTemplateCardBox:{
        backgroundColor: 'rgba(230, 0, 1, 0.09)',
        padding:'1rem',
        border:0,
        borderRadius:'4px',
    },
    selectedTemplate:{
        boxShadow: '-3px 4px 1px #ec2828'
    },
    selectbtn:{
        color: '#fff',
        border: '1px solid',
        borderColor:'#e60000', 
        display: 'block',
        padding: '0.5rem',
        fontSize: '1rem',
        boxSizing: 'border-box',
        textAlign: 'center',
        transition: 'all 300ms ease',
        fontFamily: 'VodafoneRg-Regular',
        borderRadius: '5px',
        backgroundColor: '#e60000',
    }
    
}));

const IdeaTemplateSelectCard = (props) => {
    const { ideaName,currentIndex,onClick,selectedTemplateId,templatelistId} = props || {}
  
  const classes =  useStylesIdeaTemplateSelectCard()
    return(
        <div className={`${classes.ideaTemplateCardBox}  ${selectedTemplateId !== templatelistId ? null : classes.selectedTemplate}`}>
            {/* <span><FcIdea /></span> */}
            <h3 className={classes.labelName}>{ideaName}</h3>
            {selectedTemplateId !== templatelistId ? <button type='button' onClick={onClick} className={classes.selectbtn}>Select</button> : 
            <button type='button' className={classes.selectbtn}>Selected</button> }
        </div>
    )
}